import { render, staticRenderFns } from "./statementTablePrint.vue?vue&type=template&id=4caca05e&scoped=true&"
import script from "./statementTablePrint.vue?vue&type=script&lang=js&"
export * from "./statementTablePrint.vue?vue&type=script&lang=js&"
import style0 from "./statementTablePrint.vue?vue&type=style&index=0&id=4caca05e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4caca05e",
  null
  
)

export default component.exports